<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Dokumenta</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Dokumenta</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col class="d-flex mt-3" cols="12">
                  <v-btn
                    depressed
                    small
                    tile
                    color="primary"
                    :to="{name: 'dokumenta-create'}"
                  >
                    Dodaj novi dokument
                  </v-btn>
                </v-col>

                <v-progress-linear
                        class="my-4"
                        indeterminate
                        color="primary"
                        v-if="loading"
                ></v-progress-linear>

                <v-col cols="8">
                    <v-text-field
                      label="Pretraga"
                      v-model="search"
                      outlined
                      dense
                      clearable
                      class="py-2"
                    >
                    </v-text-field>
                    <v-treeview
                            v-model="tree"
                            v-if="items.length"
                            open-all
                            :items="items"
                            selection-type="independent"
                            color="warning"

                            return-object
                            selectable
                            on-icon="mdi-eye"
                            off-icon="mdi-eye-outline"
                    >
                        <template v-slot:prepend="{ item }">
                            <span class="overline">ID:{{item.id}}</span>
                        </template>
                        <template v-slot:append="{ item, open }">
                            <span class="caption" v-if="item.category && item.category.name">{{item.category.name}}</span>
                            <v-btn icon
                                   :to="{name: 'dokumenta-create', params: {item: {parent: {id: item.id, name: item.name}, langs: []}, sub: true}}">
                                <v-icon small>{{'mdi-plus'}}</v-icon>
                            </v-btn>
                            <v-btn icon :to="{name: 'dokumenta-create', params: {item: item}}">
                                <v-icon small>{{'mdi-pencil'}}</v-icon>
                            </v-btn>
                            <v-btn icon @click="remove(item)">
                                <v-icon small>{{'mdi-delete'}}</v-icon>
                            </v-btn>
                        </template>
                    </v-treeview>
                </v-col>

                <v-col cols="4">
                    <div class="title font-weight-light grey--text pa-4 text-center" v-if="tree && tree.length === 0">
                        Klikom na
                        <v-icon>mdi-eye</v-icon>
                        prikazi dokument.
                    </div>
                    <div v-else class="pa-2">
                        <span class="subtitle-2">{{details.name}}</span><br>
                        <span class="caption">{{details.description}}</span><br>
                        <a :href="details.path" target="_blank">{{details.name}}</a>
                    </div>
                </v-col>


            </v-row>
            <confirm-dialog ref="confirmBox"></confirm-dialog>
            <snackbar
                    :text="snackbar.text"
                    :color="snackbar.color"
                    v-model="snackbar.display">
            </snackbar>
        </v-col>
    </v-row>
</template>

<script>
	import bitPage from "../../components/layout/page";
	import config from "../../config";
	import confirmDialog from '../../components/global/confirm'
	import hasSnackbar from '@/mixins/hasSnackbar'

	export default {
		mixins: [hasSnackbar],
		components: {
			bitPage,
			confirmDialog
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Dokumnta',
					disabled: true
				},
			],
			headers: [
				{text: 'ID', value: 'id'},
				{text: 'Name', value: 'name'},
				{text: 'Category', value: 'category.name'},
				{text: 'Publish data', value: 'publish_date2'},
				{text: 'Option', value: 'option'}
			],
			items: [],
			$items: [],
			tree: [],
			loading: false,
      search: ''
		}),
		created() {
			this.getDoc();
		},
		methods: {
			getDoc() {
				this.loading = true;
				this.items = [];
				this.$items = [];
				this.axios.get(`/document`)
				.then(res => {
					res.data.forEach(item => {
						let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
						item['name'] = lang && lang.name ? lang.name : '';
						if (item.children) this.loop(item.children);
						if (item['name'] !== '') this.items.push(item)
					})
          this.$items = this.items
				})
				.finally(() => this.loading = false);
			},
			loop(items) {
				items.forEach(item => {
					let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
					item['name'] = lang && lang.name ? lang.name : '';
					if (item.children) this.loop(item.children)
				})
			},
			remove(item) {
				this.$refs.confirmBox.open('Remove document', 'Are you sure want to delete this document?')
				.then(() => {
					this.axios.delete(`/document/${item.id}`)
                    .then(() => {
	                    this.items.splice(this.items.indexOf(item), 1);
	                    this.snackbar.color = 'success';
	                    this.snackbar.text = 'Document successfully removed'
                    })
                    .catch(() => {
	                    this.snackbar.color = 'error';
	                    this.snackbar.text = 'Whoops. Some error occured.'
                    })
                    .finally(() => this.snackbar.display = true)
				})
			}
		},
		computed: {
			setLang() {
				return this.$store.state.lang.code === 'en'
					? 'en' : this.$store.state.lang.code === 'la'
						? 'sr' : 'ћи'
			},
			details() {
				let details = this.tree[0].langs.find(item => item.lang.lang_code === this.setLang);

				if (details) {
					details.path = config.apiUrl + '/data/' + this.$store.state.site.id  + '/documents/' + details.document_id + '/' + details.file;
					//details.path = this.website + '/documents/' + details.id + '/' + details.file;
					return details;
				}
			}
		},
		watch: {
			setLang() {
				this.getDoc();
			},
			tree() {
				this.tree.length > 1 && this.tree.shift();
			},
      search() {
        if(this.search) {
          this.items = this.items.filter(item => item.name.includes(this.search))
        }
        else {
          this.items = this.$items
        }
      }
		}
	}
</script>
